import React from 'react'

const ImageUploadContext = React.createContext();

export default ImageUploadContext